module.exports = __webpack_public_path__ + "img/video811.be42c433.jpg";